export const calculateElapsedDays = (choosenDate) => {
  const currentDate = new Date();
  const differenceInTime = currentDate.getTime() - choosenDate.getTime();
  const numberOfDays = Math.round(differenceInTime / (1000 * 3600 * 24));
  return numberOfDays;
};
